import { render, staticRenderFns } from "./widgetVideo.vue?vue&type=template&id=bbf12a46&scoped=true&"
import script from "./widgetVideo.vue?vue&type=script&lang=js&"
export * from "./widgetVideo.vue?vue&type=script&lang=js&"
import style0 from "./widgetVideo.vue?vue&type=style&index=0&id=bbf12a46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf12a46",
  null
  
)

export default component.exports